import { isCorrectMealSize } from '../isCorrectMealSize/isCorrectMealSize';
import { IMenuProduct, IResponseProduct, IResponseProductSize } from '~/types/products';

export const getFirstCorrectMealSize = (product: IMenuProduct | IResponseProduct): IResponseProductSize | null => {
  const currentSizeIsCorrect: boolean = isCorrectMealSize(product.items, product.size);

  if (currentSizeIsCorrect) return product.size;
  if (!product.sizes.length) return null;

  return product.sizes.find((size) => isCorrectMealSize(product.items, size)) || null;
};
